import React from "react";

const Tables = () => {
  return (
    <div>
      <section role="table-wrapper">
        <table role="report-table">
          <thead role="table-header">
            <tr>
              <th>This </th>
              <th>is a </th>
              <th>
                <span>Raandom</span>
              </th>
              <th>
                <span className="clipped">MyStrengthBook</span>
              </th>
              <th>Table</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Please</td>
              <td>dont </td>
              <td>make</td>
              <td>fun</td>
              <td>of me</td>
            </tr>
            <tr>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
            </tr>
            <tr>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
              <td>lorem ipsum</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Tables;
